import React, {Component} from 'react'

import Screen from '../ui/Screen'
import ErrorMessageDialog from '../ui/ErrorMessageDialog'

import ControlPanel from "./UsersScreen/ControlPanel"
import UsersList from "./UsersList.js"
import CreateUserDialog from "./UsersScreen/CreateUserDialog"
import EditUserDialog from "./UsersScreen/EditUserDialog"
import DeleteUserDialog from "./UsersScreen/DeleteUserDialog"

import api from "../api.js"

class UsersScreen extends Component {

	constructor(props) {
		
		super(props)

		this.state = {
			selected: undefined,
			dialog: undefined,
			users: [],
		}

		this.handle_createUserClick = this.handle_createUserClick.bind(this)
		this.handle_editUserClick = this.handle_editUserClick.bind(this)
		this.handle_deleteUserClick = this.handle_deleteUserClick.bind(this)
		this.handle_userClick = this.handle_userClick.bind(this)
		this.handle_error = this.handle_error.bind(this)
		this.update = this.update.bind(this)

	}

	permissionNameToPermissionCode(name) {
		switch (name) {
			case "admin": return "2"
			case "worker": return "3"
			case "artist": return "4"
			default: return "1"
		}
	}

	permissionCodeToPermissionName(code) {
		switch (code) {
			case "2": return "admin"
			case "3": return "worker"
			case "4": return "artist"
			default: return "nobody"
		}
	}

	update = async () => await api.users.list().then(response => this.setState({users: response.users}))

	componentDidMount() {
		this.update().catch(this.handle_error)
	}

	handle_error(error) {
        let message = error instanceof String ? error : error.message
		this.setState({
			dialog: <ErrorMessageDialog 
				message = {message}
				onClose = {() => {
					this.update()
						.then(() => this.setState({dialog: undefined}))
						.catch(this.handle_error)
				}}
			/>
		})
	}

	handle_createUserClick() {
		this.setState({
			dialog: <CreateUserDialog
				onCreateUser = {user => api.users.create(user.name, user.password, user.email, user.permission)
					.then(response => this.update().then(() => this.setState({dialog: undefined, selected: this.state.users.find(u => u.id == response.id)})))
					.catch(this.handle_error)
				}
				onCancel = {() => this.setState({dialog: undefined})}
			/>
		})
	}

	handle_editUserClick(user) {
		api.users.get(user.id)
			.then(response => this.setState({
				dialog: <EditUserDialog
					user = {response.user}
					onUpdateClick = {user => api.users.update(user.id, user.name, user.password, user.email, user.permission)
						.then(this.update)
						.then(() => this.setState({dialog: undefined, selected: this.state.users.find(u => u.id === this.state.selected.id)}))
						.catch(this.handle_error)
					}
					onCancelClick = {() => this.setState({dialog: undefined})}
				/>
			}))
			.catch(this.handle_error)		
	}

	handle_deleteUserClick(user) {
		this.setState({
			dialog: <DeleteUserDialog
				user = {user}
				onDeleteClick = {user => {
					api.users.delete(user.id)
						.then(this.update)
						.then(this.setState({dialog: undefined}))
						.catch(this.handle_error)
				}}
				onCancelClick = {() => this.setState({dialog: undefined})}
			/>
		})
	}

	handle_userClick(user) {
		if (this.state.selected && this.state.selected.id === user.id) {
			this.handle_editUserClick(user)
		} else {
			this.setState({selected: user})
		}
	}

	render() {

		return <Screen>

			{this.state.dialog}

			<ControlPanel
				selected = {this.state.selected}
				onCreateUserClick = {this.handle_createUserClick}
				onEditUserClick = {this.handle_editUserClick}
				onDeleteUserClick = {this.handle_deleteUserClick}
			/>

			<UsersList
				users = {this.state.users}
				selected = {this.state.selected}
				onUserClick = {this.handle_userClick}	
			/>

		</Screen>

	}

}

export default UsersScreen
